import React from 'react';
import { useModal } from '@ampol/design-system';
import XeroTermsAndConditions from '../components/accounting-integration/xero-terms-and-conditions';
import MyobTermsAndConditions from '../components/accounting-integration/myob-terms-and-conditions';

/**
 * Accounting Integration Modals Hook
 *
 * Manages modal state and configuration for Xero and MYOB terms and conditions.
 *
 * @returns {Object} Modal instances with open/close methods
 */
export const useAccountingIntegrationModals = () => {
  const xeroTermsAndConditionsModal = useModal({
    id: 'xeroTermsAndConditions',
    title: 'AmpolCard Data Transfer to Xero Terms and Conditions',
    content: <XeroTermsAndConditions />,
    variant: 'triple',
    color: 'blue',
    actions: [
      {
        label: 'Back',
        onClick: () => xeroTermsAndConditionsModal.close(),
      },
    ],
  });

  const myobTermsAndConditionsModal = useModal({
    id: 'myobTermsAndConditions',
    title: 'Terms and Conditions',
    content: <MyobTermsAndConditions />,
    variant: 'triple',
    color: 'blue',
    actions: [
      {
        label: 'Back',
        onClick: () => myobTermsAndConditionsModal.close(),
      },
    ],
  });

  return {
    xeroTermsAndConditionsModal,
    myobTermsAndConditionsModal,
  };
};
